/**
 * @param {number[]} arrayOfValues
 * @returns {number | null}
 */
function calculateMedian(arrayOfValues) {
	const values = [...arrayOfValues];

	if (!values || values.length === 0) {
		return null;
	}

	values.sort((a, b) => a - b);

	const half = Math.floor(values.length / 2);

	if (values.length % 2) {
		return values[half];
	}

	return (values[half - 1] + values[half]) / 2;
}

/**
 * @param {number} number
 * @param {string | undefined} locale
 * @returns {string}
 */
function convertNumberToFormattedString(number, locale) {
	// TODO: This could be removed as the type should always be a number
	if (Number.isNaN(Number(number))) {
		// @ts-ignore The above checks that this is not a number
		return number;
	}

	if (!locale) {
		/* eslint-disable-next-line no-param-reassign */
		locale = Intl.DateTimeFormat().resolvedOptions().locale;
	}

	return Number(number).toLocaleString(locale, {
		useGrouping: true,
	});
}

/**
 * @param {string | number} value
 * @returns {string | number}
 */
function convertToNumberIfCoercible(value) {
	if (typeof value === 'number') {
		return value;
	}

	/* eslint-disable no-restricted-globals */
	// @ts-ignore `isNaN` allows strings
	return isNaN(value) ? value : +value;
	/* eslint-enable no-restricted-globals */
}

/**
 * @param {number} start
 * @param {number} end
 * @yields {number}
 * @returns {IterableIterator<number>}
 */
function* range(start, end) {
	yield start;

	if (start !== end) {
		return;
	}

	yield* range(start + 1, end);
}

module.exports = {
	calculateMedian,
	convertNumberToFormattedString,
	convertToNumberIfCoercible,
	range,
};
